import Commissions from '../Commissions';
import StoreCommission from '../StoreCommission';
import ReactLoading from 'react-loading';
import ActivationsInsights from '../Charts/ActivationsInsights/ActivationsInsights';
import Revenues from '../Charts/Revenues/Revenues';
import Barcharts from '../Charts/Barcharts/Barcharts';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import {
  //  getFilterdByDate, getEventCisData,
  getRevenueAndActivationByYear,
} from '../../helper/helper';
// import { format, startOfMonth, addMonths, endOfMonth } from 'date-fns';
import { useEffect, useMemo, useState } from 'react';
// import { removeDuplicatesByInvoice } from '../ReusableFunctions';
import { ADMIN_ROLE } from './utils';
import DashBoardPieChart from './DashBoardPieChart';
import { getLastNYearsOptions } from '../ReusableFunctions';


const DashboardCharts = ({
  currentFilter,
  isLoading,
  employeeData,
  accListAR,
  accListOA,
  eventCisData,
  adjustedtarget,
  data,
  dataEvent,
  // typeSelected,
  // employeeCommissions,
  target,
  storeCommission,
  datesString = '',
}) => {
  const userDetails = useMemo(() => JSON.parse(localStorage.getItem('user_data')), []);
  // const [yearData, setYearData] = useState([]);
  const [graphsData, setGraphsData] = useState(null);
  // const [eventYearData, setEventYearData] = useState([]);
  const [loadingProgress, setLoadingProgress] = useState(true);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  // const abortControllerRef = useRef(null);

  // const fetchYearData = async (year) => {
  //   setYearData([]);
  //   setEventYearData([]);
  //   setLoadingProgress(true);

  //   abortControllerRef.current = new AbortController();
  //   const signal = abortControllerRef.current.signal;

  //   let currentMonth = new Date(year, 0, 1); // Start from January of the selected year
  //   let monthsFetched = 0;
  //   const isCurrentYear = year === new Date().getFullYear();

  //   while (currentMonth.getFullYear() === year) {
  //     const startDate = format(startOfMonth(currentMonth), 'yyyy-MM-dd');
  //     const endDate = format(endOfMonth(currentMonth), 'yyyy-MM-dd');

  //     let isDataFetched = false;

  //     try {
  //       const { data: filterData } = await getFilterdByDate({ startDate, endDate, signal });
  //       if (filterData && filterData.length > 0) {
  //         if (userDetails?.role === EMPLYEE_ROLE) {
  //           let finalArray = filterData?.filter((val) => val.user === userDetails?.username) || [];
  //           // filterData?.forEach((val) => {
  //           //   let isExist = userDetails.stores
  //           //     ?.split(',')
  //           //     .some((item) => item === val.storeInvoice);

  //           //   if (isExist) finalArray.push(val);
  //           // });

  //           const duplicateRemoved = removeDuplicatesByInvoice(finalArray);
  //           setYearData((prevData) => [...prevData, ...duplicateRemoved]);
  //         } else if (userDetails?.role === 'manager') {
  //           const finalArray = filterData?.filter((val) =>
  //             userDetails?.stores?.split(',').includes(val.storeInvoice),
  //           );

  //           const duplicateRemoved = removeDuplicatesByInvoice(finalArray);
  //           setYearData((prevData) => [...prevData, ...duplicateRemoved]);
  //         } else {
  //           setYearData((prevData) => [...prevData, ...filterData]);
  //         }
  //         isDataFetched = true;
  //       }
  //     } catch (error) {
  //       if (signal.aborted) {
  //         console.log('Fetch aborted');
  //       } else {
  //         console.error(`Error fetching filtered data for ${startDate} - ${endDate}:`, error);
  //       }
  //     }

  //     try {
  //       const { data: eventData } = await getEventCisData({ startDate, endDate, signal });
  //       if (eventData && eventData.length > 0) {
  //         if (userDetails?.role === EMPLYEE_ROLE) {
  //           // let finalArray = [];
  //           let finalArray = eventData?.filter((val) => val.user === userDetails?.username) || [];
  //           // eventData?.forEach((val) => {
  //           //   let isExist = userDetails?.stores
  //           //     ?.split(',')
  //           //     .some((item) => item === val.storeInvoice);

  //           //   if (isExist) finalArray.push(val);
  //           // });

  //           const duplicateRemoved = removeDuplicatesByInvoice(finalArray);
  //           setEventYearData((prevData) => [...prevData, ...duplicateRemoved]);
  //         } else if (userDetails?.role === 'manager') {
  //           const finalArray = eventData?.filter((val) =>
  //             userDetails.stores?.split(',').includes(val.storeInvoice),
  //           );

  //           const duplicateRemoved = removeDuplicatesByInvoice(finalArray);
  //           setEventYearData((prevData) => [...prevData, ...duplicateRemoved]);
  //         } else {
  //           setEventYearData((prevData) => [...prevData, ...eventData]);
  //         }
  //         isDataFetched = true;
  //       }
  //     } catch (error) {
  //       if (signal.aborted) {
  //         console.log('Fetch aborted');
  //       } else {
  //         console.error(`Error fetching event data for ${startDate} - ${endDate}:`, error);
  //       }
  //     }

  //     if (isDataFetched) {
  //       monthsFetched++;
  //     }

  //     currentMonth = addMonths(currentMonth, 1);

  //     if (monthsFetched === 3) {
  //       setLoadingProgress(false);
  //     }
  //     if (
  //       currentMonth.getFullYear() !== year ||
  //       (isCurrentYear && currentMonth.getMonth() > new Date().getMonth())
  //     ) {
  //       break;
  //     }
  //   }
  // };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    // fetchYearData(selectedYear);
    const getGraphData = async () => {
      setLoadingProgress(true);
      try {
        const data = await getRevenueAndActivationByYear(
          { year: selectedYear, userID: userDetails?._id },
          signal,
        );

        if (data) {
          setGraphsData(data);
          setLoadingProgress(false);
        }
        // You can set the data to a state or process it as needed
      } catch (error) {
        console.error('Error fetching revenue and activation data:', error);
      }
    };

    getGraphData();

    // return () => {
    //   if (abortControllerRef.current) {
    //     abortControllerRef.current.abort(); // Cleanup on unmount
    //   }
    // };
    return () => {
      controller.abort();
    };
    // eslint-disable-next-line
  }, [selectedYear]);

  return (
    <>
      <div className="section">
        {/* <h2>
          All Stores – Activations & Revenue
        </h2> */}

        <div className="filter-container">
          <p>Shows total activations and revenue for all stores.</p>

          <div className="yearDD">
            <FormControl>
              <InputLabel htmlFor="year-select-id" id="year-select-label">
                Select Year
              </InputLabel>
              <Select
                labelId="year-select-label"
                id="year-select"
                value={selectedYear}
                className="year-select"
                onChange={(e) => setSelectedYear(Number(e.target.value))}
                aria-labelledby="year-select-label"
                label="Select Year"
                inputProps={{
                  id: 'year-select-id',
                }}
              >
                {getLastNYearsOptions().map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>

        {/* Todo: Refactor in sepearte component to reduce rerendering */}
        <div className="charts">
          {loadingProgress ? (
            <div className="spinner-container">
              <ReactLoading type="bars" color="#09f" height={100} width={100} />
            </div>
          ) : (
            <ActivationsInsights
              // yearData={yearData}
              graphData={graphsData?.activationData || []}
              type={currentFilter}
              // eventYearData={eventYearData}
              selectedYear={selectedYear}
            />
          )}
          {loadingProgress ? (
            <div className="spinner-container">
              <ReactLoading type="bars" color="#09f" height={100} width={100} />
            </div>
          ) : (
            <Revenues
              //  yearData={yearData} type={[]} eventYearData={eventYearData}
              selectedYear={selectedYear}
              graphData={graphsData?.revenuePerMonth || []}
            />
          )}
        </div>
      </div>

      <div className="pie-charts charts">
        <DashBoardPieChart
          isLoading={isLoading}
          employeeData={employeeData}
          accListAR={accListAR}
          accListOA={accListOA}
          eventCisData={eventCisData}
          datesString={datesString}
          type={currentFilter}
          cisdata={employeeData}
        />
        <div className="block">
          <div className="block-head">
            <div className="block-title">
              <span>Target vs Achieved</span>
            </div>
          </div>
          {isLoading ? (
            <div className="spinner-container">
              <ReactLoading type="bars" color="#09f" height={100} width={100} />
            </div>
          ) : (
            <Barcharts
              target={adjustedtarget}
              achieved={data}
              dataEvent={dataEvent}
              currentFilter={currentFilter}
            />
          )}
        </div>
      </div>

      <div className="bot-widgets">
        <div className="widgetcontainer">
          <h3>
            {userDetails?.role !== ADMIN_ROLE ? 'Commission(Uploaded)' : 'Employee Commission'}
          </h3>
          {/* <Commissions
            cisdata={employeeCommissions}
            targetRow={adjustedtarget}
            data={data}
            totalTarget={target}
            currentFilter={typeSelected}
          />*/}
          <Commissions
            cisdata={employeeData}
            targetRow={adjustedtarget}
            data={data}
            totalTarget={target}
            currentFilter={currentFilter}
          />
        </div>
        {userDetails?.role === 'admin' && (
          <div className="widgetcontainer">
            <h3>Store Commission</h3>
            <StoreCommission cisdata={storeCommission} targetRow={adjustedtarget} data={data} />
          </div>
        )}
      </div>
    </>
  );
};

export default DashboardCharts;
